// extracted by mini-css-extract-plugin
export default {"container":"NvFormLayout_container__jmhDj","upperSection":"NvFormLayout_upperSection__Wl8uv","lowerSection":"NvFormLayout_lowerSection__cdWp6"};